'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var AggregateError = require('aggregate-error');

var PCancelable = require('p-cancelable');

var FilterError = /*#__PURE__*/function (_Error) {
  _inherits(FilterError, _Error);

  var _super = _createSuper(FilterError);

  function FilterError() {
    _classCallCheck(this, FilterError);

    return _super.apply(this, arguments);
  }

  return FilterError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var pSome = function pSome(iterable, options) {
  return new PCancelable(function (resolve, reject, onCancel) {
    var count = options.count,
        _options$filter = options.filter,
        filter = _options$filter === void 0 ? function () {
      return true;
    } : _options$filter;

    if (!Number.isFinite(count)) {
      reject(new TypeError("Expected a finite number, got ".concat(typeof options.count)));
      return;
    }

    var values = [];
    var errors = [];
    var elementCount = 0;
    var isSettled = false;
    var completed = new Set();

    var maybeSettle = function maybeSettle() {
      if (values.length === count) {
        resolve(values);
        isSettled = true;
      }

      if (elementCount - errors.length < count) {
        reject(new AggregateError(errors));
        isSettled = true;
      }

      return isSettled;
    };

    var cancelPending = function cancelPending() {
      var _iterator = _createForOfIteratorHelper(iterable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var promise = _step.value;

          if (!completed.has(promise) && typeof promise.cancel === 'function') {
            promise.cancel();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    onCancel(cancelPending);

    var _iterator2 = _createForOfIteratorHelper(iterable),
        _step2;

    try {
      var _loop = function _loop() {
        var element = _step2.value;
        elementCount++;

        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var value;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return element;

                case 3:
                  value = _context.sent;

                  if (!isSettled) {
                    _context.next = 6;
                    break;
                  }

                  return _context.abrupt("return");

                case 6:
                  if (filter(value)) {
                    _context.next = 8;
                    break;
                  }

                  throw new FilterError('Value does not satisfy filter');

                case 8:
                  values.push(value);
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);
                  errors.push(_context.t0);

                case 14:
                  _context.prev = 14;
                  completed.add(element);

                  if (!isSettled && maybeSettle()) {
                    cancelPending();
                  }

                  return _context.finish(14);

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11, 14, 18]]);
        }))();
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (count > elementCount) {
      reject(new RangeError("Expected input to contain at least ".concat(options.count, " items, but contains ").concat(elementCount, " items")));
      cancelPending();
    }
  });
};

module.exports = pSome;
module.exports.AggregateError = AggregateError;
module.exports.FilterError = FilterError;